import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const usePersonalDataSectionStyles = makeStyles()((theme: Theme) => ({
  inputTitle: { color: theme.palette.info.dark, textAlign: "start" },
  input: {
    borderRadius: "5px",
    height: "2rem",
    backgroundColor: "transparent"
  },
  inputError: {
    borderRadius: "5px",
    height: "2rem",
    backgroundColor: theme.palette.error.main
  },
  formControl: {
    "& .MuiOutlinedInput-root.Mui-focused": {
      "& > fieldset": {
        borderColor: theme.palette.info.dark,
      },
    },
  },
  card: {
    boxShadow: "0 0 10px rgb(0 0 0 / 0.3)",
    borderRadius: "5px",
  },
  sectionTitle: {
    textAlign: "start",
    color: theme.palette.info.dark,
    textTransform: "uppercase",
    fontWeight: 700,
    marginBottom: "1rem",
  },
  sectionTitleError: {
    textAlign: "start",
    color: theme.palette.error.main,
    textTransform: "uppercase",
    fontWeight: 700,
    marginBottom: "1rem",
  },
  inputContainer: {
    marginBottom: "1rem",
  },
  radioButton: {
    "&.MuiRadio-root": {
      color: theme.palette.primary.main,
    },
    "&.Mui-checked": {
      color: theme.palette.primary.main,
    },
  },
  radioButtonTitle: {
    color: theme.palette.info.dark,
  },
}));
